<template>
  <div id="fulfillment-container">
    <div class="content-heading">
      <i class="ic-head-icon">
        <img src="@/assets/images/sidebar/fulfillment.svg" :alt="page_title" />
      </i>
      <h4 class="head-title" v-text="page_title"/>
      <i class="ic-tooltip" id="help-fulfillment"></i>
      <b-popover
        target="help-fulfillment"
        triggers="hover"
        content="Make your customer dine-in experience better with our NEW Scan to Order features!"
      >
      </b-popover>
      <app-tab :tabs="tabs"></app-tab>
    </div>
    <transition name="fade">
      <b-alert
        v-model="isShowSaveAlert"
        class="
          rounded-0
          border-0
          text-white
          d-flex
          flex-column flex-md-row
          justify-content-between
          align-items-center
        "
        id="save-alert"
      >
        <p class="mb-0">There are unsaved changes on this page.</p>
        <div class="alert-action-buttons">
          <b-button
            pill
            variant="ghost"
            class="shadow-none mr-2"
            @click="handleCancelledChanges"
            :disabled="saving"
            >Cancel</b-button
          >
          <b-button
            pill
            variant="primary"
            @click="handleSave"
            :disabled="saving"
            >{{ saving ? "Saving Changes..." : "Save Changes" }}</b-button
          >
        </div>
      </b-alert>
    </transition>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import AppTabs from "@/components/common/AppTabs.vue";
import permission from "@/services/user.permission";

export default {
    name: "Fulfillment",
    components: {
        "app-tab": AppTabs
    },
    data() {
        return {
            tabs: [
                {
                    name: "Delivery",
                    href: "/fulfillment/delivery",
                    access: "fulfillment.delivery",
                    enabled: true
                },
                {
                    name: "Pickup",
                    href: "/fulfillment/pickup",
                    access: "fulfillment.pickup",
                    enabled: true
                },
                {
                    name: "Fees",
                    href: "/fulfillment/fees",
                    access: "fulfillment.fees",
                    enabled: true
                },
                {
                    name: "Settings",
                    href: "/fulfillment/settings",
                    access: "fulfillment.settings",
                    enabled: true
                }
            ],
            page_title: "Order Fulfillment",
            isShowSaveAlert: false
        };
    },
    computed: {
        ...mapGetters({
            saving: "orderFulfillment/saving"
        })
    },
    mounted() {
        this.$root.$on("changesDetected", () => {
            this.isShowSaveAlert = true;
        });
        this.$root.$on("fulfillmentSavedSuccessful", () => {
            this.isShowSaveAlert = false;
        });
    },
    created() {
        this.handleRouteChange();
    },
    watch: {
        $route() {
            this.handleRouteChange();
        }
    },
    beforeDestroy() {
        this.$root.$off("changesDetected");
        this.$root.$off("fulfillmentSavedSuccessful");
    },
    methods: {
        ...mapMutations({
            setErrors: "orderFulfillment/set_errors"
        }),
        handleCancelledChanges() {
            this.$root.$emit(
                "saveFulfillmentChangesCancelled",
                this.$route.name
            );
            this.isShowSaveAlert = false;
            this.setErrors(null);
        },
        handleSave() {
            this.$root.$emit("handleFulfillmentSave", this.$route.name);
        },
        handleRouteChange() {
            if (this.$route.name === "Fulfillment") {
                const tabsWithAccess = this.tabs.filter(tab =>
                    permission.hasAccess(tab.access)
                );

                if (tabsWithAccess.length)
                    this.$router.push(tabsWithAccess[0].href);
                else this.$router.push({ name: "home" });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.outline-0 {
    outline: 0;
}
#save-alert {
    background: #2f4858;
    .alert-action-buttons {
        .btn-primary {
            border-radius: 20px;
        }
        .btn-ghost:focus-visible {
            outline: 0 !important;
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
